import { Button, Stack, Typography } from '@mui/material'
import { useWindowHeight } from '@react-hook/window-size'

import { BaseLayout } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

export * from './fragments'

export type State = {}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {}

export const ResaleCreateCompletionTemplate: Template<State, Action> = () => {
  const { t } = useTranslation('resaleCreateCompletion')
  const windowHeight = useWindowHeight()
  const { routerPages, generatePath } = useRouter()

  return (
    <BaseLayout
      margin
      header={{ title: t('title') }}
      sx={{ minHeight: 'unset', height: windowHeight }}
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{ height: '100%' }}
      >
        <Stack alignItems="center">
          <Typography variant="h5">{t('message')}</Typography>
          <Typography variant="body2" pt={6} align="center">
            {t('messageDesc')}
          </Typography>
          <Stack spacing={4} mt={6} py={5}>
            <Button
              size="large"
              href={generatePath(routerPages.ResaleManagement)}
              sx={{ width: 244, margin: 'auto' }}
              color="primary"
            >
              {t('resaleManagementScreen')}
            </Button>
            <Button
              variant="text"
              href={routerPages.Top}
              size="large"
              sx={{ width: 244, margin: 'auto' }}
              color="primary"
            >
              {t('topPage')}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </BaseLayout>
  )
}
